import { useGetAllOrganizationsQuery } from '@verantos-dev/data-access-organizations';
import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useOrganizationsListTable } from '../hooks/useOrganizationsListTable';

export const OrganizationsListTable = () => {
  const { organizationsTableColumns } = useOrganizationsListTable();

  const useOrganizationsDataGridFetch = (searchParams?: string) => {
    return useGetAllOrganizationsQuery(searchParams || '');
  };

  return (
    <DataGridLayout id="organizations-datagrid-layout">
      <DataGrid
        id="organizations-list"
        mode="server"
        getRowId={(row) => row.organizationId}
        columns={organizationsTableColumns}
        useFetchDataGridData={useOrganizationsDataGridFetch}
        getRowCount={(data) => data.pagination.total}
        pageSizeOptions={[10, 25, 50, 100]}
        initialPageSize={100}
        pagination
        disableSearchParamSync
        initialState={{
          sorting: {
            sortModel: [{ field: 'name', sort: 'asc' }],
          },
        }}
        slotProps={{
          columnHeaders: {
            style: {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              lineHeight: 'normal',
              padding: '16px 24px',
              fontWeight: '500',
              fontSize: '14px',
              // TODO: no VDS token for this value — needs designer input (Barry Richardson)
              color: '#252A36',
            },
          },
        }}
      />
    </DataGridLayout>
  );
};
